import { all } from 'redux-saga/effects';

import appSaga from './appSaga';
import homeSaga from './homeSaga';
import viewerSaga from './viewerSaga';
import imageSaga from './imageSaga';
import reportSaga from './reportSaga';
import plotSaga from './plotSaga';
import plotViewerSaga from './plotViewerSaga';

export default function* rootSaga() {
    yield all([
        appSaga(), homeSaga(), viewerSaga(), imageSaga(), reportSaga(), plotSaga(), plotViewerSaga(),
    ]);
}
